import {apiClient} from '@common/http/query-client';
import {useQuery} from '@tanstack/react-query';

export type AvatarProfile = {
  created_at: string;
  id: number;
  order: number;
  type: 'kid' | 'teenage' | 'adult';
  updated_at: string;
  url: string;
};

export const useGetAvatarList = () => {
  return useQuery({
    queryKey: ['avatar_list'],
    queryFn: getAvatarList,
  });
};

const getAvatarList = async (): Promise<AvatarProfile[]> => {
  return await apiClient.get('user-profile/avatar-list').then(res => res.data);
};
